import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCandidatePredictionIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	height: "1em",
	width: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		fill: "currentColor",
		height: 24,
		width: 24
	})
});
export default SvgCandidatePredictionIcon;
